module.exports = __webpack_public_path__ + "static/media/arrotek.2d19aa54.png";